// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FreeActivationButton_wrapper__aqasd","button":"FreeActivationButton_button__HcuL7"};